//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.MoveBuilder.js";
import "../CAM/CAM.ReferenceVector.js";
import "../CAM/CAM.ReferencePoint.js";
import "../CAM/CAM.ExpressionDouble.js";
let d=[[[0,"ArcAxis",1,"Direction",1],[0,"ArcAxisType",1,0],[1,"ArcAxisVectorBuilder",0,"CAM.ReferenceVector",0],[0,"ArcExtendMethod",1,0],[0,"CenterPoint",1,"Point",1],[1,"CenterPointBuilder",0,"CAM.ReferencePoint",0],[0,"EndPoint",1,"Point",1],[1,"EndPointBuilder",0,"CAM.ReferencePoint",0],[0,"ExtendAngle",1,1],[1,"ExtendAngleBuilder",0,"CAM.ExpressionDouble",0],[0,"ExtendDistance",1,1],[1,"ExtendDistanceBuilder",0,"CAM.ExpressionDouble",0],[0,"MotionEndType",1,0],[0,"SweepAngle",1,1],[1,"SweepAngleBuilder",0,"CAM.ExpressionDouble",0]],[],[]];
SPLM.CAM.CircularAboutAxisMoveBuilder = class extends SPLM.CAM.MoveBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.CircularAboutAxisMoveBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.CircularAboutAxisMoveBuilder.AxisType = Object.freeze({
    "Tool" : "Tool", "Vector" : "Vector"});

SPLM.CAM.CircularAboutAxisMoveBuilder.EndType = Object.freeze({
    "Angle" : "Angle", "Point" : "Point"});

SPLM.CAM.CircularAboutAxisMoveBuilder.ExtensionType = Object.freeze({
    "Angle" : "Angle", "Distance" : "Distance"});

export default SPLM;